/* eslint-disable @typescript-eslint/camelcase */
export const ConstructionEditTabs = [
  { id: 1, tabName: '工事基本情報' },
  // タブ削除 2022/12/13 岡山
  //{ id: 2, tabName: '予定原価入力' },
  //{ id: 3, tabName: '確定原価入力' },
  { id: 4, tabName: '請求書一覧' },
  { id: 5, tabName: '使用材料明細入力' }
];

export interface SelectModalItemType {
  id: string;
  name: string;
  standard: string;
}

export interface ModalColumnType {
  label: string;
  name: string;
  columnStyle: string;
}

export const ModalColumn = [
  {
    label: '項番',
    name: '項番',
    columnStyle: 'width50px backgroundColor7cdee6 textAlignCenter'
  },
  {
    label: '材料名〈原材料費〉',
    name: '材料名〈原材料費〉',
    columnStyle: 'width300px backgroundColor7cdee6'
  },
  {
    label: '規格',
    name: '規格',
    columnStyle: 'width200px backgroundColor7cdee6'
  },
  {
    label: '仕入先名',
    name: '仕入先名',
    columnStyle: 'width200px backgroundColor7cdee6'
  }
];

export const TotalBoxType = {
  TOTALSUM: 'totalSum',
  COSTRATE: 'costRate',
  SUBTOTAL: 'subTotal'
};

export const ViewType = {
  MATERIALCOST: 'materialCost',
  LABORCOST: 'laborCost',
  CONSUMABLECOST: 'consumableCost',
  FIXLABORCOST: 'fixLaborCost',
  FIXCONSUMABLECOST: 'fixConsumableCost'
};

export const Rules = {
  RULESNUM3: 'required|numeric|max: 4',
  RULESSTR10: 'max: 10',
  RULESFILES: 'fileMaxCount:10|fileMaxSize:2048000',
};

export const FrequentlyUsedWords = {
  TO_EDIT_MODE: '編集',
  TO_LIST: '一覧へ戻る',
  UPDATE: '更新',
  CANCEL: 'キャンセル',
  FORM_DOWNLOAD: '帳票ダウンロード',
  FILE_MANAGE: '添付ファイル',
  REGISTER_COPY_DATA: 'コピーして新規登録'
};

export const ExpectedCostInputItemHeader = {
  SCREENTITLE: '予定原価入力',
  CONTROLNUMBER: '管理番号',
  CONSTRUCTIONNAME: '工事名',
  COSTTOTAL: '予定原価合計',
  COSTRATE: '予定原価率',
  MATERIALCOST: '予定原価(材料費)',
  LABORCOST: '予定原価(労務費)',
  CONSUMABLECOST: '予定原価(消耗品・その他経費)',
  SUBTOTAL: '小計'
};

export const FixedCostInputItemHeader = {
  SCREENTITLE: '確定原価入力',
  CONTROLNUMBER: '管理番号',
  CONSTRUCTIONNAME: '工事名',
  COSTTOTAL: '確定原価合計',
  COSTRATE: '確定原価率',
  MATERIALCOST: '確定原価(材料費)',
  LABORCOST: '確定原価(労務費)',
  CONSUMABLECOST: '確定原価(消耗品・その他経費)',
  SUBTOTAL: '小計'
};

/**
 * 工事詳細のカラム
 */
export interface ColumnFormatType {
  name: string;
  columnStyle: string;
  style: string;
  type: string;
  value: string;
}

/**
 * 材料費関係の定義
 */
export type ExpectedCostInputMaterialCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    material_id: string;
    quantity: string;
    unit: string;
    unit_price: string;
    name: string;
    standard: string;
  }
];

export interface ExpectedCostInputMaterialCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  material_id: string;
  quantity: string;
  unit: string;
  unit_price: string;
  name: string;
  standard: string;
}

export const ExpectedCostInputMaterialCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  material_id: '',
  quantity: '',
  unit: '',
  unit_price: '',
  name: '',
  standard: ''
};

/**
 * 労務費関係の定義
 */
export type ExpectedCostInputLaborCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    work_type: string;
    others: string;
    quantity: string;
    unit: string;
    unit_price: string;
  }
];

export interface ExpectedCostInputLaborCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  work_type: string;
  others: string;
  quantity: string;
  unit: string;
  unit_price: string;
}

export const ExpectedCostInputLaborCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  work_type: '',
  others: '',
  quantity: '',
  unit: '',
  unit_price: ''
};

/**
 * 消耗品・その他関係の定義
 */
export type ExpectedCostInputConsumableCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    account_title: string;
    others: string;
    quantity: string;
    unit: string;
    unit_price: string;
  }
];

export interface ExpectedCostInputConsumableCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  account_title: string;
  others: string;
  quantity: string;
  unit: string;
  unit_price: string;
}

export const ExpectedCostInputConsumableCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  account_title: '',
  others: '',
  quantity: '',
  unit: '',
  unit_price: ''
};

/*
export const MaterialDBCostItemColumn = ['項番', '材料名〈原材料費〉', '規格'];
*/
/**
 * 材料費関係の定義
 */
export type FixedCostInputMaterialCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    material_id: string;
    quantity: string;
    unit: string;
    unit_price: string;
    name: string;
    standard: string;
  }
];

export interface FixedCostInputMaterialCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  material_id: string;
  quantity: string;
  unit: string;
  unit_price: string;
  name: string;
  standard: string;
}

export const FixedCostInputMaterialCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  material_id: '',
  quantity: '',
  unit: '',
  unit_price: '',
  name: '',
  standard: ''
};

/**
 * 労務費関係の定義
 */
export type FixedCostInputLaborCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    work_type: string;
    others: string;
    quantity: string;
    unit: string;
    unit_price: string;
  }
];

export interface FixedCostInputLaborCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  work_type: string;
  others: string;
  quantity: string;
  unit: string;
  unit_price: string;
}

export const FixedCostInputLaborCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  work_type: '',
  others: '',
  quantity: '',
  unit: '',
  unit_price: ''
};

/**
 * 消耗品・その他関係の定義
 */
export type FixedCostInputConsumableCostItemArray = [
  {
    i_id: string;
    id: string;
    construction_id: string;
    account_title: string;
    others: string;
    quantity: string;
    unit: string;
    unit_price: string;
  }
];

export interface FixedCostInputConsumableCostItemType {
  i_id: string;
  id: string;
  construction_id: string;
  account_title: string;
  others: string;
  quantity: string;
  unit: string;
  unit_price: string;
}

export const FixedCostInputConsumableCostItem = {
  i_id: '',
  id: '',
  construction_id: '',
  account_title: '',
  others: '',
  quantity: '',
  unit: '',
  unit_price: ''
};

export const TabTest = [
  { label: 'test1' },
  { label: 'test2' },
  { label: 'test3' },
  { label: 'test4' }
];

export const MaterialCostItem = [
  '',
  '項番',
  '材料名〈原材料費〉',
  '規格',
  '数量',
  '単位',
  '単価',
  '合計'
];

/*
export const LaborCostItemColumn = [
  '',
  '項番',
  '工種〈労務費〉',
  'その他',
  '数量',
  '単位',
  '単価',
  '合計'
];
*/
/*
export const ConsumableCostItemColumn = [
  '',
  '項番',
  '〈消耗・その他経費〉',
  'その他',
  '数量',
  '単位',
  '単価',
  '合計'
];
*/
export const MaterialCostColumnFormat = [
  {
    name: '',
    columnStyle: 'width90px',
    style: 'blankItem',
    type: 'text',
    value: ''
  },
  {
    name: '項番',
    columnStyle: 'width0px',
    style: 'width50px textAlignCenter',
    type: 'text',
    value: ''
  },
  {
    name: '材料名〈原材料費〉',
    columnStyle: 'width300px',
    style: 'width300px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '規格',
    columnStyle: 'width100px',
    style: 'width100px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '数量',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight righted-input',
    type: 'number',
    value: null
  },
  {
    name: '単位',
    columnStyle: 'width90px',
    style: 'width90px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '単価',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight righted-input',
    type: 'number',
    value: null
  },
  {
    name: '合計',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'number',
    value: null
  }
];

export const LaborCostColumnFormat = [
  {
    name: '',
    columnStyle: 'width90px',
    style: 'blankItem',
    type: 'text',
    value: 'true'
  },
  {
    name: '項番',
    columnStyle: 'width50px',
    style: 'width50px textAlignCenter',
    type: 'text',
    value: 'true'
  },
  {
    name: '工種〈労務費〉',
    columnStyle: 'width300px',
    style: 'width300px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: 'その他',
    columnStyle: 'width200px;',
    style: 'width200px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '数量',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '単位',
    columnStyle: 'width90px',
    style: 'width90px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '単価',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '合計',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'number',
    value: null
  }
];

export const ConsumableCostColumnFormat = [
  {
    name: '',
    columnStyle: 'width90px',
    style: 'blankItem',
    type: 'text',
    value: 'true'
  },
  {
    name: '項番',
    columnStyle: 'width50px',
    style: 'width50px textAlignCenter',
    type: 'text',
    value: 'true'
  },
  {
    name: '〈消耗・その他経費〉',
    columnStyle: 'width300px',
    style: 'width300px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: 'その他',
    columnStyle: 'width200px;',
    style: 'width200px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '数量',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '単位',
    columnStyle: 'width90px',
    style: 'width90px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '単価',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '合計',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'number',
    value: null
  }
];

export const FixLaborCostColumnFormat = [
  {
    name: '',
    columnStyle: 'width90px',
    style: 'blankItem',
    type: 'text',
    value: 'true'
  },
  {
    name: '項番',
    columnStyle: 'width50px',
    style: 'width50px textAlignCenter',
    type: 'text',
    value: 'true'
  },
  {
    name: '工種〈労務費〉',
    columnStyle: 'width300px',
    style: 'width300px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: 'その他',
    columnStyle: 'width200px;',
    style: 'width200px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '数量',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '単位',
    columnStyle: 'width90px',
    style: 'width90px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '単価',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '合計',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '請求月',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'text',
    value: null
  }
];

export const FixConsumableCostColumnFormat = [
  {
    name: '',
    columnStyle: 'width90px',
    style: 'blankItem',
    type: 'text',
    value: 'true'
  },
  {
    name: '項番',
    columnStyle: 'width50px',
    style: 'width50px textAlignCenter',
    type: 'text',
    value: 'true'
  },
  {
    name: '〈消耗・その他経費〉',
    columnStyle: 'width300px',
    style: 'width300px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: 'その他',
    columnStyle: 'width200px;',
    style: 'width200px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '数量',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '単位',
    columnStyle: 'width90px',
    style: 'width90px textAlignLeft',
    type: 'text',
    value: ''
  },
  {
    name: '単価',
    columnStyle: 'width90px',
    style: 'width90px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '合計',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'number',
    value: null
  },
  {
    name: '請求月',
    columnStyle: 'width100px',
    style: 'width100px textAlignRight',
    type: 'text',
    value: null
  }
];

export type ConstructionInfoType = {
  id: string;
  period: string;
  construction_no: string;
  constructionSubject: {
    disabled: boolean;
    select: { value: number; text: string };
    options: [{ value: number; text: string }];
  };
  controlName: string;
  estimate_order_price: string;
};
